$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'event-group') {
        CKEDITOR.replace('event_group_notice');
        CKEDITOR.replace('event_group_participation_modalities');
        CKEDITOR.replace('event_group_email_text');
        CKEDITOR.replace('event_group_email_signature');
        CKEDITOR.replace('event_group_notice_de');
        CKEDITOR.replace('event_group_participation_modalities_de');
        CKEDITOR.replace('event_group_email_text_de');
        CKEDITOR.replace('event_group_email_signature_de');



        $('body').on('click', '#submitForm', function(e) {
            e.preventDefault();

            let fd = new FormData();

            fd.append('id', $('#id').val())
            fd.append('event_group_identifier', $('#event_group_identifier').val())
            fd.append('event_group_start', $('#event_group_start').val())
            fd.append('event_group_end', $('#event_group_end').val())
            fd.append('event_group_notice', CKEDITOR.instances.event_group_notice.getData())
            fd.append('event_group_notice_de', CKEDITOR.instances.event_group_notice_de.getData())
            fd.append('event_group_participation_modalities', CKEDITOR.instances.event_group_participation_modalities.getData())
            fd.append('event_group_participation_modalities_de', CKEDITOR.instances.event_group_participation_modalities_de.getData())
            fd.append('event_group_email_subject', $('#event_group_email_subject').val())
            fd.append('event_group_email_subject_de', $('#event_group_email_subject_de').val())
            fd.append('event_group_email_reply_to', $('#event_group_email_reply_to').val())
            fd.append('event_group_email_text', CKEDITOR.instances.event_group_email_text.getData())
            fd.append('event_group_email_text_de', CKEDITOR.instances.event_group_email_text_de.getData())
            fd.append('event_group_email_signature', CKEDITOR.instances.event_group_email_signature.getData())
            fd.append('event_group_email_signature_de', CKEDITOR.instances.event_group_email_signature_de.getData())
            fd.append('event_group_publish', $('#event_group_publish').val())

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                url:'/event-group-save',
                type:'POST',
                data: fd,
                contentType: false,
                processData: false,
                success: function(response) {
                    if ($('#id').val().length === 0) {
                        window.location.href = window.location.href + '/' + response.e.id;
                    } else {
                        window.location.reload();
                    }

                },
            });
        });
    }
});
